"use client"

import * as React from "react"
import { Sparkles } from "lucide-react"

import { cn } from "../../lib/utils"

export interface SignalCardProps {
  className?: string
  name: string
  message: string
  networkMessage?: string
}

function SignalCard({
  className,
  name,
  message,
  networkMessage,
}: SignalCardProps) {
  return (
    <div
      className={cn(
        "bg-white border border-black rounded-lg p-4 shadow-[0px_4px_0px_0px_#000000]",
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="size-4 text-[#ED5AA9]" />
        <span className="text-sm font-medium text-[#ED5AA9]">
          {name}, we saw the signals —
        </span>
      </div>

      {/* Message */}
      <p className="text-sm text-[#344054] leading-relaxed mb-3">{message}</p>

      {/* Network Message */}
      {networkMessage && (
        <p className="text-sm text-[#344054] leading-relaxed">{networkMessage}</p>
      )}
    </div>
  )
}

export { SignalCard }
